'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _taggedTemplateLiteral2 = require('babel-runtime/helpers/taggedTemplateLiteral');

var _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2);

var _redboxReact2 = require('redbox-react');

var _redboxReact3 = _interopRequireDefault(_redboxReact2);

var _react2 = require('react');

var _react3 = _interopRequireDefault(_react2);

var _reactTransformCatchErrors3 = require('react-transform-catch-errors');

var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);

var _dec, _dec2, _class, _class2, _temp;

var _templateObject = (0, _taggedTemplateLiteral3.default)(['\n  font-size: ', ';\n  color: ', ';\n\n  @media (max-width: 700px) {\n    font-size: 25px;\n  }\n'], ['\n  font-size: ', ';\n  color: ', ';\n\n  @media (max-width: 700px) {\n    font-size: 25px;\n  }\n']),
    _templateObject2 = (0, _taggedTemplateLiteral3.default)(['\n  color: ', ';\n  font-size: 14px;\n  display: flex;\n  width: fit-content;\n  height: fit-content;\n  font-weight: 700;\n'], ['\n  color: ', ';\n  font-size: 14px;\n  display: flex;\n  width: fit-content;\n  height: fit-content;\n  font-weight: 700;\n']),
    _templateObject3 = (0, _taggedTemplateLiteral3.default)(['\n  font-size: 20px;\n'], ['\n  font-size: 20px;\n']);

var _Link = require('components/Link/Link');

var _Link2 = _interopRequireDefault(_Link);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _tmtUiKit = require('tmt-ui-kit');

var _reactRedux = require('react-redux');

var _reactIntl = require('react-intl');

var _toast = require('redux/modules/toast');

var toastActions = _interopRequireWildcard(_toast);

var _reactRouterRedux = require('react-router-redux');

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _Toast = require('./Toast.scss');

var _Toast2 = _interopRequireDefault(_Toast);

var _media = require('utils/media');

var _momentTimezone = require('moment-timezone');

var _momentTimezone2 = _interopRequireDefault(_momentTimezone);

var _helpers = require('utils/helpers');

var _reactFontawesome = require('react-fontawesome');

var _reactFontawesome2 = _interopRequireDefault(_reactFontawesome);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _components = {
  Toast: {
    displayName: 'Toast'
  }
};

var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
  filename: '/home/runner/work/redux-frontend/redux-frontend/src/components/Toast/Toast.js',
  components: _components,
  locals: [],
  imports: [_react3.default, _redboxReact3.default]
});

function _wrapComponent(id) {
  return function (Component) {
    return _reactTransformCatchErrors2(Component, id);
  };
}
// import _ from 'lodash';


_momentTimezone2.default.tz.setDefault('Asia/Bangkok');


var Container = _styledComponents2.default.div.withConfig({
  displayName: 'Toast__Container',
  componentId: 'sc-m0a7pi-0'
})(['transition:1s all;z-index:8000;position:fixed;width:', ';top:130px;right:', ';padding-right:', ';@media (max-width:700px){width:', ';top:103px;padding-right:0;', ' ', ';}'], function (props) {
  return props.isToastsIn ? 'fit-content' : '400px';
}, function (props) {
  return props.isToastsIn ? '0' : '-400px';
}, function (props) {
  return props.isNotiVerify ? '0' : '10px';
}, function (props) {
  return props.isNotiVerify ? 'fit-content' : '100%';
}, function (props) {
  return props.isNotiVerify && 'right: 0;';
}, function (props) {
  return props.isToastsIn && !props.isNotiVerify && 'left: 0;';
});

var NotiVerifyContainer = _styledComponents2.default.div.withConfig({
  displayName: 'Toast__NotiVerifyContainer',
  componentId: 'sc-m0a7pi-1'
})(['display:', ';justify-content:flex-end;margin-bottom:12px;'], function (props) {
  return props.closed ? 'none' : 'flex';
});

var NotiVerift = _styledComponents2.default.div.withConfig({
  displayName: 'Toast__NotiVerift',
  componentId: 'sc-m0a7pi-2'
})(['position:relative;display:flex;background:', ';box-shadow:0 2px 8px 0 rgba(0,0,0,0.15);border-top-left-radius:6px;border-bottom-left-radius:6px;', ' @media (max-width:700px){display:block;', '}'], function (props) {
  return props.theme.pink;
}, function (props) {
  return props.isToggleNotiVerify ? '\n    padding: 30px 16px 16px;\n  ' : '\n    cursor: pointer;\n    padding: 10px;\n  ';
}, function (props) {
  return props.isToggleNotiVerify ? '\n      width: 259px;\n      padding: 17px 16px 16px;\n    ' : '\n      padding: 8px 6px 6px;\n    ';
});

var IconContainer = _styledComponents2.default.div.withConfig({
  displayName: 'Toast__IconContainer',
  componentId: 'sc-m0a7pi-3'
})(['', ''], function (props) {
  return props.isToggleNotiVerify && '\n    margin-top: 10px;\n    margin-right: 10px;\n  ';
});

var Icon = _tmtUiKit.Icon.extend(_templateObject, function (props) {
  return props.isToggleNotiVerify ? '40px' : '33px';
}, function (props) {
  return props.theme.red;
});

var IconArrow = _tmtUiKit.Icon.extend(_templateObject2, function (props) {
  return props.theme.darkBlue;
});

var MessageNotiVerift = _styledComponents2.default.div.withConfig({
  displayName: 'Toast__MessageNotiVerift',
  componentId: 'sc-m0a7pi-4'
})(['a{display:flex;align-items:center;color:', ';font-weight:500;margin-top:16px;width:fit-content;margin:auto;margin-right:0;}'], function (props) {
  return props.theme.darkBlue;
});

var TitleVerify = _styledComponents2.default.h4.withConfig({
  displayName: 'Toast__TitleVerify',
  componentId: 'sc-m0a7pi-5'
})(['margin:10px 0 0;color:', ';'], function (props) {
  return props.theme.darkBlue;
});

var SubtitleVerify = _styledComponents2.default.p.withConfig({
  displayName: 'Toast__SubtitleVerify',
  componentId: 'sc-m0a7pi-6'
})(['margin-top:10px;line-height:0;color:', ';'], function (props) {
  return props.theme.darkBlue;
});

var IconCloseContainer = _styledComponents2.default.div.withConfig({
  displayName: 'Toast__IconCloseContainer',
  componentId: 'sc-m0a7pi-7'
})(['position:absolute;cursor:pointer;top:12px;right:12px;']);

var IconClose = _tmtUiKit.Icon.extend(_templateObject3);

var Toast = _wrapComponent('Toast')((_dec = (0, _reactRedux.connect)(function (state) {
  return {
    show: state.toast.show,
    message: state.toast.message,
    type: state.toast.type,
    toasts: state.toast.toasts,
    path: state.routing.locationBeforeTransitions.pathname
  };
}, (0, _extends3.default)({}, toastActions, { push: _reactRouterRedux.push })), _dec2 = (0, _reactCssModules2.default)(_Toast2.default), _dec(_class = _dec2(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(Toast, _Component);

  function Toast(props) {
    (0, _classCallCheck3.default)(this, Toast);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Toast.__proto__ || (0, _getPrototypeOf2.default)(Toast)).call(this, props));

    _this.getStyle = function () {
      var _this$props = _this.props,
          show = _this$props.show,
          type = _this$props.type;

      if (show) {
        if (type === 'success') {
          return 'toast-success-in';
        } else if (type === 'warning') {
          return 'toast-warning-in';
        } else if (type === 'error') {
          return 'toast-error-in';
        }
      } else {
        if (type === 'success') {
          return 'toast-success';
        } else if (type === 'warning') {
          return 'toast-warning';
        } else if (type === 'error') {
          return 'toast-error';
        }
      }
      return 'toast';
    };

    _this.state = {
      isToggleNotiVerify: false
    };
    return _this;
  }

  (0, _createClass3.default)(Toast, [{
    key: 'componentWillUpdate',
    value: function componentWillUpdate(props) {
      var _this2 = this;

      // if (this.props.show === false && props.show === true) {
      //   setTimeout(() => {this.props.closeToast();}, 3000);
      // }
      if (this.props.toasts.length < props.toasts.length) {
        var last = props.toasts[props.toasts.length - 1];
        if (last.id && last.timeout > 0) {
          setTimeout(function () {
            return _this2.props.closeToast(last.id);
          }, last.timeout);
        }
      }
    }
  }, {
    key: 'closeToast',
    value: function closeToast(id) {
      this.props.closeToast(id);
    }
  }, {
    key: 'clickRedeemReminder',
    value: function clickRedeemReminder(id, code) {
      this.props.logClickToast('promo_code', code);
      if (!this.props.path.startsWith('/to')) {
        this.props.push('/to/Any');
      }
      this.props.closeToast(id);
    }
  }, {
    key: 'clickInstantTomorrow',
    value: function clickInstantTomorrow(id) {
      this.props.logClickToast('instant_tomorrow');
      this.props.closeToast(id);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var toasts = this.props.toasts;
      var isToggleNotiVerify = this.state.isToggleNotiVerify;

      var count = toasts.filter(function (t) {
        return t.closed;
      }).length;
      var instantUrl = (0, _helpers.getInstantUrl)();
      var isNotiVerify = toasts.find(function (t) {
        return t.type === 'noti-verify';
      }) ? true : false;

      return _react3.default.createElement(
        Container,
        {
          isToastsIn: toasts.length > count,
          isNotiVerify: isNotiVerify
        },
        toasts.map(function (t, i) {
          if (t.type === 'noti') {
            return _react3.default.createElement(
              'div',
              { styleName: t.closed ? 'toast-noti' : 'toast-noti-in', key: t.id },
              _react3.default.createElement(
                _Link2.default,
                { to: t.link, styleName: 'toast-link', onClick: _this3.closeToast.bind(_this3, t.id) },
                _react3.default.createElement(
                  'div',
                  { styleName: 'toast-content-container' },
                  t.is_admin !== 'admin' && _react3.default.createElement('div', { styleName: 'noti-pic', style: t && t.sender_id && t.sender_id.avatar_image && (0, _media.path)(t.sender_id.avatar_image, 'profileNoti', true) }),
                  _react3.default.createElement(
                    'p',
                    { styleName: 'noti-message' },
                    t.message
                  )
                )
              ),
              _react3.default.createElement(
                'div',
                { styleName: 'close-noti-container', onClick: _this3.closeToast.bind(_this3, t.id) },
                _react3.default.createElement(_reactFontawesome2.default, { name: 'times' })
              )
            );
          }
          if (t.type === 'noti-verify') {
            return _react3.default.createElement(
              NotiVerifyContainer,
              { closed: t.closedNoti, key: t.id },
              _react3.default.createElement(
                NotiVerift,
                {
                  onClick: function onClick() {
                    return !isToggleNotiVerify && _this3.setState({ isToggleNotiVerify: true });
                  },
                  isToggleNotiVerify: isToggleNotiVerify
                },
                _react3.default.createElement(
                  IconContainer,
                  { isToggleNotiVerify: isToggleNotiVerify },
                  _react3.default.createElement(Icon, { name: 'warning', isToggleNotiVerify: isToggleNotiVerify })
                ),
                isToggleNotiVerify && !t.closedNoti && _react3.default.createElement(
                  MessageNotiVerift,
                  null,
                  _react3.default.createElement(
                    IconCloseContainer,
                    {
                      onClick: function onClick() {
                        return _this3.setState({ isToggleNotiVerify: false });
                      }
                    },
                    _react3.default.createElement(IconClose, { name: 'close' })
                  ),
                  _react3.default.createElement(
                    TitleVerify,
                    null,
                    t.message
                  ),
                  _react3.default.createElement(
                    SubtitleVerify,
                    null,
                    'so we can approve your trip.'
                  ),
                  _react3.default.createElement(
                    _Link2.default,
                    { onClick: function onClick() {
                        return _this3.setState({ isToggleNotiVerify: false });
                      }, to: t.link },
                    'click ',
                    _react3.default.createElement(IconArrow, { name: 'chevron-right' })
                  )
                )
              )
            );
          }
          if (t.type === 'instant') {
            return _react3.default.createElement(
              'div',
              { styleName: t.closed ? 'toast-noti' : 'toast-noti-in', key: t.id },
              _react3.default.createElement(
                _Link2.default,
                { to: instantUrl, styleName: 'toast-link', onClick: _this3.clickInstantTomorrow.bind(_this3, t.id) },
                _react3.default.createElement(
                  'div',
                  { styleName: 'toast-content-container' },
                  _react3.default.createElement('div', { styleName: 'instant-pic' }),
                  _react3.default.createElement(
                    'p',
                    { styleName: 'noti-message' },
                    _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'home.home_landing.instant_booking' })
                  )
                )
              ),
              _react3.default.createElement(
                'div',
                { styleName: 'close-noti-container', onClick: _this3.closeToast.bind(_this3, t.id) },
                _react3.default.createElement(_reactFontawesome2.default, { name: 'times' })
              )
            );
          }
          if (t.type === 'redeem') {
            return _react3.default.createElement(
              'div',
              { styleName: t.closed ? 'toast-noti' : 'toast-noti-in', key: t.id },
              _react3.default.createElement(
                'a',
                { styleName: 'toast-link', onClick: _this3.clickRedeemReminder.bind(_this3, t.id, t.code) },
                _react3.default.createElement(
                  'div',
                  { styleName: 'toast-content-container' },
                  _react3.default.createElement('div', { styleName: 'noti-redeem-pic' }),
                  t.expires_at ? _react3.default.createElement(
                    'p',
                    { styleName: 'noti-message' },
                    _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'toast.promo.date',
                      values: {
                        discount: t.percentage ? t.percentage * 100 + '%' : t.constant + ' ' + t.currency,
                        date: (0, _momentTimezone2.default)(t.expires_at).format('ll')
                      }
                    })
                  ) : _react3.default.createElement(
                    'p',
                    { styleName: 'noti-message' },
                    _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'toast.promo',
                      values: {
                        discount: t.percentage ? t.percentage * 100 + '%' : t.constant + ' ' + t.currency
                      }
                    })
                  )
                )
              ),
              _react3.default.createElement(
                'div',
                { styleName: 'close-noti-container', onClick: _this3.closeToast.bind(_this3, t.id) },
                _react3.default.createElement(_reactFontawesome2.default, { name: 'times' })
              )
            );
          }
          var type = t.type || 'success';
          var toastContent = [_react3.default.createElement(
            'div',
            { styleName: 'toast-content-container', key: 'content-' + i + '-0' },
            _react3.default.createElement(
              'p',
              null,
              t.message
            )
          ), _react3.default.createElement(
            'div',
            { styleName: 'close-container', key: 'content-' + i + '-1' },
            _react3.default.createElement(_reactFontawesome2.default, { name: 'times' })
          )];
          if (t.link) {
            return _react3.default.createElement(
              _Link2.default,
              { styleName: t.closed ? 'toast-' + type : 'toast-' + type + '-in', onClick: _this3.closeToast.bind(_this3, t.id), key: t.id, to: t.link },
              toastContent
            );
          }
          return _react3.default.createElement(
            'div',
            { styleName: t.closed ? 'toast-' + type : 'toast-' + type + '-in', onClick: _this3.closeToast.bind(_this3, t.id), key: t.id },
            toastContent
          );
        })
      );
    }
  }]);
  return Toast;
}(_react2.Component), _class2.propTypes = {
  show: _react2.PropTypes.bool,
  message: _react2.PropTypes.string,
  type: _react2.PropTypes.string,
  closeToast: _react2.PropTypes.func,
  toasts: _react2.PropTypes.array,
  path: _react2.PropTypes.string,
  push: _react2.PropTypes.func,
  logClickToast: _react2.PropTypes.func
}, _temp)) || _class) || _class));

exports.default = Toast;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Toast/Toast.js
// module id = 1625
// module chunks = 47